import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { transformRequest } from "../../../utils";
import { CAPTCHA_ENDPOINT, CAPTCHA_RESPONSE_TYPE } from "../constants";
export var fetchCaptcha = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var captcha, _yield$axios$get, headers, data, _JSON$parse, pic, captchakey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          captcha = {
            captchakey: '',
            pic: ''
          };
          _context.prev = 1;
          _context.next = 4;
          return axios.get(CAPTCHA_ENDPOINT, {
            transformRequest: transformRequest,
            withCredentials: true,
            responseType: 'blob',
            params: params
          });
        case 4:
          _yield$axios$get = _context.sent;
          headers = _yield$axios$get.headers;
          data = _yield$axios$get.data;
          if (headers['content-type'].includes(CAPTCHA_RESPONSE_TYPE.IMG)) {
            captcha.pic = URL.createObjectURL(data);
          }
          if (!headers['content-type'].includes(CAPTCHA_RESPONSE_TYPE.JSON)) {
            _context.next = 18;
            break;
          }
          _context.t0 = JSON;
          _context.next = 12;
          return data.text();
        case 12:
          _context.t1 = _context.sent;
          _JSON$parse = _context.t0.parse.call(_context.t0, _context.t1);
          pic = _JSON$parse.captcha;
          captchakey = _JSON$parse.captchakey;
          captcha.captchakey = captchakey;
          captcha.pic = "data:image/png;base64,".concat(pic);
        case 18:
          _context.next = 23;
          break;
        case 20:
          _context.prev = 20;
          _context.t2 = _context["catch"](1);
          console.error(_context.t2);
        case 23:
          return _context.abrupt("return", captcha);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 20]]);
  }));
  return function fetchCaptcha(_x) {
    return _ref.apply(this, arguments);
  };
}();